import React from 'react';
import {useTimeFormatter} from '../../data/hooks/datetimeHooks';

const EventTime = props => {
    const {time} = props,
        formatTime = useTimeFormatter( );

    return <>{formatTime(time)}</>;
};

export default EventTime;
